import { NavLink, NavLinkProps } from "react-router-dom";
import * as React from 'react';
import { MenuItem } from "../Sidebar";
import Icon from "../../Icon";
import classNames from "classnames";
import style from '../Sidebar.scss';

const linkClassName: NavLinkProps['className'] = ({ isActive }) => classNames(style.item, isActive && style.itemActive);

type Props<S extends Record<string, any> = {}> = {
  item: MenuItem<S>,
  context: S,
};

const SidebarItem: React.FunctionComponent<Props> = (props) => {
  const { item: { url, exact, icon, title, tag, isActive }, context } = props;

  const to = typeof url === 'function' ? url(context) : url;
  const aside = typeof tag === 'function' && tag();

  if (typeof isActive === 'function' && !isActive(context)) return null;

  return (
    <NavLink
      to={to}
      className={linkClassName}
      end={exact}
    >
      {icon
        ? <Icon className={style.itemIcon} icon={icon} />
        : <span className={style.itemIcon} />
      }
      <span className={style.itemText}>{title}</span>
      {aside}
    </NavLink>
  );
};

export default React.memo(SidebarItem);
